import CoachAdapter from './base';

export default class GoalPlan extends CoachAdapter {
  modelNamePlural = 'goalPlans';
}
